import { createContext, useContext } from 'react';

const PreviewContext = createContext({ isOpen: false, toggle: () => {} });

export const usePreview = () => useContext(PreviewContext);
export default PreviewContext;
